<template>
  <a-modal
    v-model="showModal"
    title="Edit languages"
    :footer="null"
    width="400px"
    :destroyOnClose="true"
    :closable="false"
    class="edit-language-modal adaptive-modal"
  >
    <a-row class="d-flex flex-column">
      <div class="mb-3">
        <UniversalSelect
          v-model="selectedLanguage"
          :options="availableLanguages"
          displayOptionsAtBottom
          placeholder="Selected language"
          title="Add language"
          :showSearch="true"
          @change="addLanguage"
        />
      </div>
      <div class="edit-language-modal__languages mb-3">
        <span class="d-block mb-2 font-weight-bold font-size-16">Selected languages</span>
        <div
          v-for="(language, index) in selectedLanguages"
          :key="language.value"
          class="edit-language-modal__language cursor-pointer"
        >
          <div>
            <span>{{ language.name }}</span>
            <a-badge
              v-if="language.is_default"
              count="Default"
              :number-style="{
                backgroundColor: '#fff',
                color: '#999',
                boxShadow: '0 0 0 1px #d9d9d9 inset',
              }"
            />
          </div>
          <div>
            <span
              v-if="!language.is_default"
              class="edit-language-modal__language__set-default text-primary"
              @click="changeDefaultLanguage(index)"
            >
              Set as default
            </span>
            <a-popconfirm
              placement="left"
              title="Are you sure you want to delete this language?"
              @confirm="() => deleteLanguage(language, index)"
            >
              <a-icon v-if="!language.is_default" class="font-size-18 text-danger delete-icon" type="delete" />
            </a-popconfirm>
          </div>
        </div>
      </div>
    </a-row>
    <a-row class="adaptive-modal__footer">
      <a-col class="text-right" :span="24">
        <a-button @click="closeModal">
          Cancel
        </a-button>
        <a-button
          type="primary"
          class="ml-2"
          @click="save"
        >
          OK
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import UniversalSelect from '@/components/custom/filters/universalSelect.vue'
import { subscribe, unsubscribe } from '@/composables/keydownEvent.js'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    allLanguages: {
      type: Array,
      default: () => [],
    },
    languagesUsed: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    UniversalSelect,
  },
  data: () => ({
    showModal: false,
    selectedLanguage: undefined,
    selectedLanguages: [],
  }),
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.showModal = true
        } else {
          this.showModal = false
        }
      },
      deep: true,
      immediate: true,
    },
    showModal: {
      handler(val) {
        if (!val) {
          this.closeModal()
        }
      },
      deep: true,
    },
  },
  computed: {
    availableLanguages() {
      return this.allLanguages
        .filter(lang => !this.selectedLanguages.some(sel => sel.value === lang.id))
        .map(lang => ({
          name: lang.name,
          value: lang.id,
        }))
    },
  },
  methods: {
    setSelectedLanguages() {
      this.selectedLanguages = JSON.parse(JSON.stringify(this.languagesUsed))
    },
    addLanguage(value) {
      const lang = this.availableLanguages.find(lang => lang.value === value)
      if (!lang) return

      this.selectedLanguages.push({ ...lang, is_default: false })
      this.selectedLanguage = undefined
    },
    changeDefaultLanguage(langIndex) {
      this.selectedLanguages = this.selectedLanguages.map((lang, idx) => ({
        ...lang,
        is_default: idx === langIndex,
      }))
    },
    deleteLanguage(lang, langIdx) {
      const wasDefault = lang.is_default
      this.selectedLanguages.splice(langIdx, 1)
      if (wasDefault && this.selectedLanguages.length) {
        this.selectedLanguages[0].is_default = true
      }
    },
    async save() {
      this.$emit('update', this.selectedLanguages)
      this.closeModal()
    },
    closeModal() {
      this.$emit('close')
    },
  },
  mounted() {
    this.setSelectedLanguages()
    subscribe(this.save)
  },
  beforeDestroy() {
    unsubscribe()
  },
}
</script>

<style lang="scss">
.edit-language-modal {
  &__languages {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  &__language {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    border: 1px solid #e4e9f0;
    border-radius: 4px;
    max-width: 400px;
    padding: 0 10px;
    &:hover {
      border-color: #40a9ff;
    }
    & > div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    &__set-default {
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
